import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { defaultTemplate } from 'core/hoc';
import { Date } from 'core/components';

function FormatterResolver({ item, field, format }) {
    switch (format.type) {
        case 'date': 
            return <Date value={_.get(item, field)} format={format.value} />
        default:
            return () => {};
    }
}

FormatterResolver.propTypes = {
    item: PropTypes.object,
    field: PropTypes.object,
    format: PropTypes.object
};

export default defaultTemplate(FormatterResolver);